import React, { useState } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import { NotificationManager } from "react-notifications";
import * as API from "../api/index";
import { useDataView } from "../../contexts/data.view.context";
import { FormField, FormSelectField, FormActions } from "../util/formFields";

const ViewEditFileTransfer = ({
  curRow,
  handleDetailClose,
  editable,
  onEditClick,
  data,
}) => {
  const { fetchFileTransfersFromAllEnv } = useDataView();
  const values = curRow.original;

  const [formData, setFormData] = useState({
    _pkTransfer: values._pkTransfer,
    TRANSFER_ID: values.TRANSFER_ID,
    PROJECT_ID: values.PROJECT_ID,
    COMMANDS: values.COMMANDS_TEXT,
    STATE: values.STATE,
    TRANSFER_TYPE: values.TRANSFER_TYPE,
    RETENTION_DAYS: values.RETENTION_DAYS,
    COMMENTS: values.COMMENTS,
  });

  const states = ["Active", "Closed", "Pending", "Locked"];

  function handleSubmit(event) {
    event.preventDefault();
    const payload = [
      {
        _pkTransfer: values._pkTransfer,
        TRANSFER_ID: formData.TRANSFER_ID,
        STATE: formData.STATE,
        TRANSFER_TYPE: formData.TRANSFER_TYPE,
        RETENTION_DAYS: formData.RETENTION_DAYS,
        COMMENTS: formData.COMMENTS,
        COMMANDS: formData.COMMANDS,
      },
    ];

    const resourcePath = "integrations/cfg/transfers";

    API.UpdateRecord(resourcePath, payload).then((response) => {
      if (response.code === 200) {
        fetchFileTransfersFromAllEnv();
        NotificationManager.success("Record Updated", "File Transfer", 10000);
      } else {
        NotificationManager.error(response.message, "Failed!", 10000);
      }
    });
  }

  function handleChange(event) {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }

  return (
    <Box>
      <Stack spacing={0}>
        <FormField required id="TRANSFER_ID" name="TRANSFER_ID" label="Transfer ID" disabled value={formData.TRANSFER_ID} onChange={handleChange} />
        <FormField required id="PROJECT_ID" name="PROJECT_ID" label="Project ID" disabled={!editable} value={formData.PROJECT_ID} onChange={handleChange} />
        <FormSelectField id="STATE" name="STATE" label="State" disabled={!editable} value={formData.STATE} onChange={handleChange} items={states} />
        <FormField required id="TRANSFER_TYPE" name="TRANSFER_TYPE" label="Transfer Type" disabled={!editable} value={formData.TRANSFER_TYPE} onChange={handleChange} />
        <FormField required id="RETENTION_DAYS" name="RETENTION_DAYS" label="Retention Days" disabled={!editable} value={formData.RETENTION_DAYS} onChange={handleChange} />
        <FormField
          required
          id="COMMANDS"
          name="COMMANDS"
          label="Commands"
          disabled={!editable}
          value={formData.COMMANDS}
          onChange={handleChange}
          multiline
          rows={5}
          inputProps={{ style: { resize: "both" } }}
        />
        <FormField required id="COMMENTS" name="COMMENTS" label="Comments" disabled={!editable} value={formData.COMMENTS} onChange={handleChange} />
      </Stack>

      <FormActions>
        <Button variant="outlined" disabled={editable} onClick={onEditClick}>
          Edit
        </Button>
        <Button variant="contained" color="primary" disabled={!editable} onClick={handleSubmit}>
          Save
        </Button>
        <Button variant="text" color="inherit" onClick={handleDetailClose}>
          Close
        </Button>
      </FormActions>
    </Box>
  );
};

export default ViewEditFileTransfer;
